/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";

import { Button, SimpleModal } from "UpduoLibrary";
import { skaleRed, skalePrimaryBlue, skaleWhite } from "config/UpduoColors";

export default function ConfirmDiscardModal({
  visible,
  onCancelDiscard,
  onConfirmDiscard,
}) {
  return (
    <SimpleModal
      isVisible={visible}
      onClose={onCancelDiscard}
      description={
        "You have unsaved changes.\nAre you sure you want to discard?"
      }
      buttons={[
        <Button
          key={"stay"}
          text={"Stay"}
          onPress={onCancelDiscard}
          width={330}
          height={60}
          marginTop={20}
          borderColor={skalePrimaryBlue}
        />,
        <Button
          key={"discard"}
          text={"Discard"}
          onPress={onConfirmDiscard}
          width={330}
          height={60}
          borderWidth={1}
          marginTop={20}
          borderColor={skaleRed}
          color={skaleWhite}
          textColor={skaleRed}
        />,
      ]}
    />
  );
}
